var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#636874",
    d: "M29.378 5.123c-.346-1.228-1.362-2.197-2.652-2.525C24.386 2 15.005 2 15.005 2s-9.383 0-11.721.598C1.992 2.926.976 3.893.63 5.123.004 7.351.004 12.001.004 12.001s0 4.648.626 6.877c.346 1.23 1.362 2.198 2.654 2.526 2.34.596 11.72.596 11.72.596s9.382 0 11.722-.596c1.29-.33 2.308-1.297 2.652-2.526.626-2.229.626-6.877.626-6.877s0-4.649-.626-6.878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.285 16.933 7.978-4.966L12.285 7z"
  })));
};
export default SvgIconYoutube;